// Brand data for BrandShowcase component
export const brandShowcaseData = [
    {
        name: 'Alfa Romeo',
        image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80'
    },
    {
        name: 'Audi',
        image: 'https://images.unsplash.com/photo-1610768764270-790fbec18178?w=800&q=80'
    },
    {
        name: 'BMW',
        image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&q=80'
    },
    {
        name: 'Aston Martin',
        image: 'https://images.unsplash.com/photo-1604609628197-9e5f40d6d582?w=800&q=80'
    },
    {
        name: 'Bentley',
        image: 'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=800&q=80'
    },
    {
        name: 'Chevrolet',
        image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&q=80'
    },
    {
        name: 'Chrysler',
        image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800&q=80'
    },
    {
        name: 'Citroen',
        image: 'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=800&q=80'
    },
    {
        name: 'Case',
        image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&q=80'
    },
    {
        name: 'Mercedes',
        image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80'
    },
    {
        name: 'Porsche',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80'
    },
    {
        name: 'Volkswagen',
        image: 'https://images.unsplash.com/photo-1622353219448-46a2c7b0c3c1?w=800&q=80'
    }
];